module.exports = {
  xooply: 'xooply',
  callpro: 'callpro',
  prakerja: 'prakerja',
  warungMekaar: 'warung_mekaar',
  idfood: 'idfood',
  madaniMart: 'madani_mart',
};
